/** Zeven achtergrondkleuren die met WITTE tekst allemaal boven 4,5:1 uitkomen
 *  (gemeten: 5,1 · 6,2 · 5,6 · 7,2 · 6,1 · 5,1 · 7,4). De lichtere merkkleuren
 *  uit het diagrammenpalet halen dat niet — daar zou "RI" op oranje op 2,9:1
 *  uitkomen en dat is bij 11 px geen leesbare tekst maar een vlek. */
export const PERSOON_KLEUREN = ['#B45309', '#0369A1', '#0F766E', '#6D28D9', '#BE185D', '#4D7C0F', '#475569'];

/** Zelfde naam → altijd dezelfde kleur, ook tussen sessies en gebruikers.
 *  Daardoor herken je een collega aan de kleur zolang er geen foto is.
 *
 *  Geëxporteerd omdat het storingsdienstrooster dezelfde kleur per persoon
 *  gebruikt voor zijn weekbalken. Eén palet: wie in de teamchat blauw is, is
 *  blauw in het rooster. Een tweede palet zou dat verband breken én opnieuw op
 *  contrast nagemeten moeten worden. */
export function colorFor(name: string): string {
  let hash = 0;
  const key = name.toLowerCase();
  for (let i = 0; i < key.length; i++) hash = (hash * 31 + key.charCodeAt(i)) >>> 0;
  return PERSOON_KLEUREN[hash % PERSOON_KLEUREN.length]!;
}

function initialsOf(name: string): string {
  const words = name.trim().split(/[\s._-]+/).filter(Boolean);
  if (words.length >= 2) return (words[0]![0]! + words[words.length - 1]![0]!).toUpperCase();
  return name.trim().slice(0, 2).toUpperCase() || '?';
}

export interface AvatarPerson {
  username: string;
  avatar?: string | null;
}

/** Gezicht van een collega: de foto als die er is, anders de initialen in een
 *  vaste kleur. Altijd `aria-hidden` plus een titel — de naam staat er in de
 *  interface altijd naast, dus een schermlezer zou hem anders dubbel voorlezen. */
export function Avatar({ person, name, size = 28, className = '' }: {
  person?: AvatarPerson | null;
  /** Val terug op deze naam als de persoon niet in de personenlijst staat
   *  (verwijderd account, of een notitie van vóór zijn vertrek). */
  name?: string;
  size?: number;
  className?: string;
}) {
  const label = person?.username || name || '?';
  const px = `${size}px`;

  if (person?.avatar) {
    return (
      <img
        src={person.avatar}
        alt=""
        aria-hidden
        title={label}
        width={size}
        height={size}
        loading="lazy"
        style={{ width: px, height: px }}
        className={`shrink-0 rounded-full object-cover ring-1 ring-hairline ${className}`}
      />
    );
  }

  return (
    <span
      aria-hidden
      title={label}
      style={{ width: px, height: px, background: colorFor(label), fontSize: `${Math.round(size * 0.4)}px` }}
      className={`inline-flex shrink-0 items-center justify-center rounded-full font-semibold text-white select-none ${className}`}
    >
      {initialsOf(label)}
    </span>
  );
}
